import * as React from "react";
import { IconProps } from "./IconProps";

export const IconEdit = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5273 1.52864C10.7876 1.26829 11.2098 1.26829 11.4701 1.52864L14.4701 4.52864C14.7305 4.78899 14.7305 5.2111 14.4701 5.47145L5.4701 14.4714C5.34508 14.5965 5.17551 14.6667 4.9987 14.6667H1.9987C1.63051 14.6667 1.33203 14.3682 1.33203 14V11C1.33203 10.8232 1.40227 10.6537 1.52729 10.5286L10.5273 1.52864ZM9.94151 4.00004L11.9987 6.05723L13.0559 5.00004L10.9987 2.94285L9.94151 4.00004ZM11.0559 7.00004L8.9987 4.94285L2.66536 11.2762V13.3334H4.72256L11.0559 7.00004Z"
          fill={color}
        />
      </svg>
    );
  },
);
